export const addKakaoChannel = () => {
  window.open(
    `https://pf.kakao.com/${process.env.REACT_APP_KAKAO_CHANNEL_PUBLIC_ID}/chat`
  );
};
